import { useAppContext } from "../../context/AppContext";

export const useModals = () => {
  const { updateContext } = useAppContext();

  const setOpenPrn = () => {
    updateContext("openPRN", true);
  };

  const setOpenPermit = (status) => {
    updateContext("openPermit", true);
    updateContext("permitStatus", status);
  };

  const openCertificate = () => {
    updateContext("openCertificate", true);
  };

  return { setOpenPrn, setOpenPermit, openCertificate };
};
